import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
ReactDOM.render(<App />, document.querySelector('#root'));

document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
//Or you can do it where ever you want, base on user selected language, or something else
// serviceWorker.unregister();
